import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=426e1020&scoped=true&"
import script from "./FacebookLogin.vue?vue&type=script&lang=js&"
export * from "./FacebookLogin.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=426e1020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e1020",
  null
  
)

export default component.exports